import { SITE_ORIGIN, SOCIAL_PROFILES } from "@/lib/seo";

/**
 * Authoritative business configuration for Optimize Plus.
 * This file centralizes all verified business, contact, and brand data.
 */

export const siteConfig = {
  name: "Optimize Plus",
  tagline: "Austin-based SEO & AI-Search Consultancy",
  origin: SITE_ORIGIN,
  logo: {
    url: "/logo.png",
    mark: "/logo-mark.png",
    wordmark: "/logo-wordmark.png",
    alt: "Optimize Plus Logo",
  },
  contact: {
    phone: "+1 (737) 321-0551",
    phoneNumeric: "17373210551",
    email: "info@optimizeplus.net",
    address: {
      street: "1431 Salem Meadow Cir",
      city: "Austin",
      state: "TX",
      zip: "78745",
      country: "US",
      coordinates: { lat: 30.2211, lng: -97.7994 },
    },

    whatsapp: {
      number: "17373210551",
      display: "+1 (737) 321-0551",
      message: "Hi Optimize Plus — I'd like to talk about SEO for my business.",
    },
  },
  founder: {
    name: "M. Umair Mansha",
    title: "Founder & Lead Strategist",
    bio: "M. Umair Mansha is a technical SEO specialist and the founder of Optimize Plus. With over a decade of experience in engineering organic growth for automotive, HVAC, and B2B brands, he leads every strategic engagement personally.",
  },

  social: {
    profiles: SOCIAL_PROFILES,
    facebook: "https://www.facebook.com/optimizplus",
    instagram: "https://www.instagram.com/optimize.plus/",
    twitter: "https://x.com/optimize_plus",
    youtube: "https://www.youtube.com/@OptimizePlus",
    linkedin: "https://www.linkedin.com/company/optimizplus",
    yelp: "https://yelp.com/biz/optimize-plus-austin",
  },
  theme: {
    colors: {
      primary: "#FF4438", // The exact brand accent
      background: "#0A0C10", // Premium dark navy/near-black
    },
    breakpoints: {
      xs: 320,
      sm: 375,
      mobileLarge: 430,
      md: 768,
      lg: 1024,
      xl: 1280,
      "2xl": 1440,
      "3xl": 1600,
      "4xl": 1920,
    },
  },
};

export type SiteConfig = typeof siteConfig;
